export const constants = {
    PATH_CHOOSE_MANUALLY_CAPITAL_ONE_FLOW: '/ssr/flowType/ChooseManuallyOrCapitalOne',
    LOG_EXTERNAL_VENDOR:'/pages/sms/ess/v3/ws/rest/pub/ssr/logExtVendor'
};